import { Button, Card, Grid, Text, TextInput } from '@mantine/core';
import { IconCopy } from '@tabler/icons-react';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import copyText from '../../helpers/copyText';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';

const fetchDebounced = AwesomeDebouncePromise((fetch, accountId, domainId, searchTerms) => {
  return fetch(
    `/api/admin/accounts/${accountId}/domains/${domainId}/assets${searchTerms ? `?searchTerms=${searchTerms}` : ''}`
  );
}, 300);

const AssetList = ({ onSelect }) => {
  const { accountId, domainId } = useParams();

  const [error, setError] = useState();
  const [searchTerms, setSearchTerms] = useState();
  const [assets, setAssets] = useState();

  const fetch = useFetch();

  useEffect(() => {
    fetchDebounced(fetch, accountId, domainId, searchTerms)
      .then(({ assets }) => {
        setAssets(assets);
      })
      .catch(setError);
  }, [accountId, domainId, searchTerms, fetch]);

  const onSearchClick = (value) => {
    setSearchTerms(value);
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!assets) {
    return <Spinner />;
  }

  const assetElements = [];
  for (let i = 0; i < assets.length; i++) {
    const asset = assets[i];

    assetElements.push(
      <Card
        key={asset.id}
        mb="lg"
        component="a"
        style={{ cursor: 'pointer' }}
        onClick={() => copyText(`p-${asset.id}-url`)}
        withBorder
      >
        <Card.Section ta="left" bg="white" inheritPadding py="sm">
          <Grid>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <div style={{ overflow: 'auto' }}>
                <img
                  alt="asset"
                  src={asset.thumbUrl}
                  style={{ marginBottom: 'var(--mantine-spacing-sm)' }}
                  onClick={() => copyText(`p-${asset.id}-url`)}
                />
              </div>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <div>
                <Text size="sm" c="dimmed">
                  Title:
                </Text>
                <Text size="sm">{asset.title}</Text>
              </div>
              <div>
                <Text size="sm" c="dimmed">
                  Image URL:
                </Text>
                <Text size="sm" c="dimmed">
                  <span id={`p-${asset.id}-url`}>{asset.url}</span>
                  <Button variant="subtle" size="compact-xs" c="dimmed" onClick={() => copyText(`p-${asset.id}-url`)}>
                    <IconCopy size={14} />
                  </Button>
                </Text>
              </div>
            </Grid.Col>
          </Grid>
          {onSelect ? (
            <Grid>
              <Grid.Col span={12} ta="right">
                <Button onClick={() => onSelect(asset)}>Select</Button>
              </Grid.Col>
            </Grid>
          ) : (
            ''
          )}
        </Card.Section>
      </Card>
    );
  }

  return (
    <>
      <>
        <small>Search and select an image</small>
        <br />
        <TextInput
          onKeyUp={(event) => onSearchClick(event.target.value)}
          type="search"
          placeholder="Search"
          mr="xs"
          aria-label="Search"
        />
      </>
      {assetElements}
    </>
  );
};

export default AssetList;
